import PropTypes from 'prop-types';
import roleDisabled from 'services/roleDisabled/index';

const propTypes = {
  userPerms: PropTypes.arrayOf(PropTypes.string),
  userRoles: PropTypes.arrayOf(PropTypes.string),
  perms: PropTypes.arrayOf(PropTypes.string),
  roles: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
};

const defaultProps = {
  userPerms: null,
  userRoles: null,
  perms: null,
  roles: null,
  disabled: false,
};

export function RBACWrapper({ userPerms, userRoles, perms, roles, ...rest }) {
  const { children } = rest;
  const hasPerm = !perms || !roleDisabled(userPerms, perms);
  const hasRole = !roles || !roleDisabled(userRoles, roles);
  return hasPerm && hasRole && children;
}

RBACWrapper.propTypes = propTypes;
RBACWrapper.defaultProps = defaultProps;

export default RBACWrapper;
